'use client';

import { signIn, signOut } from 'next-auth/react';
import { ACCOUNT_SWITCH_START_PATH } from './switch-account';

/**
 * Schritt 1: Kontowechsel anstoßen. Der Route Handler baut die Keycloak-
 * Logout-URL serverseitig (dort liegt der Issuer) und leitet dorthin weiter.
 * Bewusst ein harter Seitenwechsel statt Router-Navigation — es geht auf eine
 * fremde Origin.
 */
export function startAccountSwitch(): void {
  window.location.href = ACCOUNT_SWITCH_START_PATH;
}

/**
 * Schritt 2: nach der Rückkehr von Keycloak den neuen Login starten.
 *
 * Die SSO-Session ist zu diesem Zeitpunkt beendet, Keycloak zeigt also die
 * freie Anmeldemaske. `prompt=login` bleibt als Absicherung gesetzt: sollte das
 * Logout doch fehlgeschlagen sein (z. B. abgelaufenes ID-Token), landet der
 * Nutzer wenigstens auf einer Anmeldemaske statt still wieder im alten Konto.
 */
export async function completeAccountSwitch(callbackUrl = '/'): Promise<void> {
  await signOut({ redirect: false });
  await signIn('keycloak', { callbackUrl }, { prompt: 'login' });
}
